/*#__PURE__*/ export default {"key":"palette.SWIPER","type":"root","items":[{"key":"SWIPER_NAVIGATION","def":"","type":"tile","tile":"PIVOT"}]};